import { render, staticRenderFns } from "./AcceptMarketingField.vue?vue&type=template&id=5aec5bf4"
import script from "./AcceptMarketingField.vue?vue&type=script&lang=ts"
export * from "./AcceptMarketingField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports